export const status = [
  { id: 'open', name: 'OPEN' },
  { id: 'close', name: 'CLOSE' },
];
